<div class="main">
  <app-handover-detail-status *ngIf="!isHOECHOAC" [handoverId]="handover?.handoverId" [wellId]="handover?.wellId"
  [uwi]="handover?.wellUwi" [handoverTypeId]="handover?.handoverTypeId" [handoverStatusId]="handover?.handoverStatusId"
  [readOnlyContent]="readOnlyContent" (sectionTouched)="onSectionTouched($event)">
</app-handover-detail-status>
<app-handover-detail-abandonment-report *ngIf="showAbandonmentReport" [handoverId]="handover?.handoverId" 
  [readOnlyContent]="readOnlyContent">
</app-handover-detail-abandonment-report>
<app-handover-detail-executive-summary *ngIf="showExecutiveSummary" [handoverId]="handover?.handoverId" 
  [readOnlyContent]="readOnlyContent" (sectionTouched)="onSectionTouched($event)" (hasPendingChanges)="emitPendingChanges($event)">
</app-handover-detail-executive-summary>
<app-handover-detail-notifications *ngIf="displayNotifications"
  [handover]="handover" [readOnlyContent]="readOnlyNotifications"
  (sectionTouched)="onSectionTouched($event)" (hasPendingChanges)="emitPendingChanges($event)">
</app-handover-detail-notifications>
</div>
